import monitorinIcon from "@assets/modules/ico/monitoreo-comunitario.svg";
import searchIcon from "@assets/modules/ico/consulta-geografica.svg";
import indicatorsIcon from "@assets/modules/ico/indicadores-biodiversidad.svg";
import portfoliosIcon from "@assets/modules/ico/portafolio.svg";
import compensationsIcon from "@assets/modules/ico/compensacion-ambiental.svg";
import alertIcon from "@assets/modules/ico/alertas-tempranas-icono.svg";

export const modulesIcons = {
  search: searchIcon,
  monitoring: monitorinIcon,
  indicators: indicatorsIcon,
  portfolios: portfoliosIcon,
  compensations: compensationsIcon,
  alert: alertIcon,
} as const;
